import { SinglePaymentResult } from '@mews-commander/data-access';
import { formatExchangeRateLabel } from '@mews/business-components';
import { DecimalService } from '@mews/framework';

export const getNormalizedData = (data: SinglePaymentResult) => {
    const { foreignExchangePaymentDetail, refundableValue, customerId, chargeAmount, refundMode } = data || {};
    const {
        chargeConversionRate,
        refundConversionRate,
        refundConversionMultiplier,
        accountingCurrencyToPaymentGatewayAmount,
    } = foreignExchangePaymentDetail || {};

    return {
        refundableValue,
        chargeAmount,
        customerId,
        refundConversionMultiplier: refundConversionMultiplier || 1,
        propertyCurrencyRefundAmount: {
            value: roundToTwoDecimals(refundableValue * Number(refundConversionMultiplier)),
            currencyCode: accountingCurrencyToPaymentGatewayAmount?.source?.currency || '',
        },
        accountingCurrencyToPaymentGatewayAmount: accountingCurrencyToPaymentGatewayAmount || {
            currency: '',
            value: 0,
        },
        chargeConversionRate: formatExchangeRateLabel({
            toCurrency: chargeConversionRate?.toCurrency,
            fromCurrency: chargeConversionRate?.fromCurrency,
        }),
        refundConversionRate: formatExchangeRateLabel({
            toCurrency: refundConversionRate?.toCurrency,
            fromCurrency: refundConversionRate?.fromCurrency,
        }),
        refundMode,
    };
};

export const roundToTwoDecimals = (value?: number) => {
    if (!value) {
        return 0;
    }

    return DecimalService.toNumber(DecimalService.round(DecimalService.parse(value), 2));
};
